// extracted by mini-css-extract-plugin
export default {"root":"classes_root__z4Btb","title":"classes_title__EEvNC"};